import { BaseService } from 'core/services';
import { DaVinciRouteService } from 'common/data';

class DaVinciService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new DaVinciRouteService());
	}

	getBusinessPartners(warehouseId, search) {
		var url = this.routeService.getBusinessPartners();
		return this.apiClient.post(url, { warehouseId, search });
	}
}

export default DaVinciService;
